export default __webpack_public_path__ + "static/media/Mohamad.0b591ca1.jpeg";